var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.16667H12V2.5C12 1.39733 11.1027 0.5 10 0.5H2C0.897333 0.5 0 1.39733 0 2.5V12.4027C0 12.932 0.29 13.416 0.756 13.6653C0.968 13.7793 1.20067 13.8353 1.43267 13.8353C1.71 13.8353 1.98667 13.7547 2.226 13.5953L4 12.4127V14.5H11.1313L13.774 16.262C14.014 16.422 14.29 16.5027 14.5673 16.5027C14.7993 16.5027 15.0313 16.446 15.244 16.332C15.7107 16.0827 16 15.5987 16 15.0693V5.16667C16 4.064 15.1027 3.16667 14 3.16667ZM1.48667 12.486C1.474 12.494 1.43667 12.518 1.38533 12.4907C1.33267 12.4627 1.33267 12.418 1.33267 12.4033V2.5C1.33267 2.132 1.632 1.83333 1.99933 1.83333H9.99933C10.3667 1.83333 10.666 2.132 10.666 2.5V10.5H4.46467L1.48667 12.486ZM14.6667 15.07C14.6667 15.084 14.6667 15.1293 14.614 15.1573C14.5613 15.1847 14.5253 15.1607 14.5133 15.1527L11.5353 13.1667H5.33333V11.8333H12V4.5H14C14.3673 4.5 14.6667 4.79867 14.6667 5.16667V15.07Z",
    fill: "#F9FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnIcon);
export default __webpack_public_path__ + "static/media/btnIcon.2e0f0a679a759b1fb0704c8db4adeaf7.svg";
export { ForwardRef as ReactComponent };